var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.49,
    height: 6,
    x: 7.207,
    y: 1,
    rx: 0.745
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.49,
    height: 6,
    x: 7.207,
    y: 9,
    rx: 0.745
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.959,
    x: 9.041,
    y: 8.75,
    rx: 0.75,
    transform: "rotate(-90 9.041 8.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.959,
    x: 1,
    y: 8.75,
    rx: 0.75,
    transform: "rotate(-90 1 8.75)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.59ebad172bc514d62fa7845c726b92a6.svg";
export { ForwardRef as ReactComponent };